import BaseModel from './BaseModel';

export default class PayAtHotel extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.profileTypeIds = data.profileTypeIds || undefined;
        this.setRatePlan(data);
    }

    setRatePlan(data = {}) {
        this.hotelRatePlans = (data.hotelRatePlans || []).map(item => new HotelRatePlan(item));
    }

    export(hasTranslate = false) {
        const result = super.export({
            profileTypeIds: this.profileTypeIds,
            hotelRatePlans: (this.hotelRatePlans || []).map(ratePlan => ratePlan.export())
        });
        return result;
    }
}

export class HotelRatePlan extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.hotelId = data.hotelId || undefined;
        this.ratePlanIds = data.ratePlanIds || undefined;
    }

    export(hasTranslate = false) {
        const result = super.export({
            hotelId: this.hotelId,
            ratePlanIds: this.ratePlanIds
        });
        return result;
    }
}

export class ProfileType extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.profileType = data.profileType || undefined;
        this.profileCode = data.profileCode || undefined;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            profileType: this.profileType,
            profileCode: this.profileCode
        });
        return result;
    }
}